import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OfflineShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"offline_share"}/>
}
